export default __webpack_public_path__ + "static/media/Phone Illustration.722d5d07.svg";